import { cn } from "@/core/helpers/cn";
import { RockStarIcon } from "@/shared/icons";

type Props = {
  className?: string;
  name: string;
};

export default function AccountSocialClub({ className, name }: Props) {
  return (
    <div className={cn("flex justify-center items-center mb-5", className)}>
      <RockStarIcon size={20} className="mr-1.5 translate-y-0.5 text-accent-solid" />
      <span className="text-accent">Social Club:</span>{" "}
      <span className="font-bold  ml-1">{name}</span>
    </div>
  );
}
